<div style="padding: 12px;background: #0E0D0D;">
    <!--    <div class="title">Application Rejected</div>-->
    <form class="example-form">
        <mat-form-field class="example-full-width" appearance="fill" style="width: 100%">
            <textarea matInput #message [(ngModel)]="msg" placeholder="The application is rejected because..."
                [ngModelOptions]="{standalone:true}"></textarea>
            <!--            <mat-hint align="end">{{message.value.length}} / 30</mat-hint>-->
        </mat-form-field>
    </form>
    <div style="text-align: end;margin-top: 11px">
        <button mat-button
            style="margin-right: 6px;color: rgba(222, 222, 222, 0.4);border: 1px solid rgba(222, 222, 222, 0.4);"
            (click)="cancel()">
            Cancel
        </button>
        <button mat-button style="color: #dedede;border: 1px solid #dedede;" (click)="reject()">
            Reject
        </button>
    </div>
</div>